import { fileToSVGElement } from './svg-utils';

export const messagesDoNotMatch = ({ message, svg }) => {
  const collapsedMessage = message.replace(/\s/g, '');
  const collapsedSvgMessage = Array.from(svg.querySelectorAll('tspan')).map(x => x.textContent).join('').replace(/\s/g, '');

  return collapsedMessage !== collapsedSvgMessage;
};

export const attemptToSyncSVGToMessage = async ({ message, svg, retryTimes = 10, retryWait = 100 }) => {
  let newSvg = svg;

  if (messagesDoNotMatch({ message, svg })) {
    let count = 0;

    while (messagesDoNotMatch({ message, svg: newSvg }) && count < retryTimes) {
      newSvg = document.getElementById('print-svg');
      await new Promise((res) => setTimeout(res, retryWait));
      count++;
    }
  }

  return newSvg;
};

export const logMessagesMismatch = ({ id, message, svg, log }) => {
  const state = JSON.stringify({
    id,
    message,
    svg: svg.outerHTML
  });

  log(new Error(`Message and SVG do not match: ${state}`));
};

export const logIfDOMMismatch = ({ message, svg, log }) => {
  if (messagesDoNotMatch({ message, svg })) {
    logMessagesMismatch({ id: 'pre-save: messages in DOM do not match' , message, svg, log });
  }
};

export const logIfFormDataMismatch = async ({ body, log }) => {

  /*
   * NOTE: this assert will not be run in IE11 since
   * `FormData` does not implement the iterator interface
   * in IE 11 we could include a polyfill if needed
   * https://github.com/jimmywarting/FormData
   */
  if (typeof body.values === 'function') {
    const [bodyMessage, bodyFile] = [...body.values()];

    const bodySVG = await fileToSVGElement(bodyFile);

    if (messagesDoNotMatch({ message: bodyMessage, svg: bodySVG })) {
      /*
       * We have seen a few issues where the svg doesn't match
       * the message in the `message` field we send to embla.
       * This is an attempt to log when that happens and
       * hopefully collect enough data to track that issue down.
       */
      logMessagesMismatch({
        id: 'pre-save: messages in form body do not match!',
        message: bodyMessage,
        svg: bodySVG,
        log: (x) => $store.log(x)
      });
    }
  }
};

export const logIfServerMismatch = ({ message, svg, log, id }) => {
  if (messagesDoNotMatch({ message, svg })) {
    logMessagesMismatch({ id: `post-save: messages for note_resource_id ${id} do not match` , message, svg, log });
  }
};
